/**
 *  Интеграция с сервисом
 *  https://support.advcake.com/docs/advdocs/integration/pixel-ecom-beauty-shop.html#js
 */
export class AdvCake {

    constructor()
    {
        this.init();
    }

    init()
    {
        window.advcake_data = window.advcake_data || [];
        return window.advcake_data;
    }

    push(query)
    {
        console.log(query);
        window.advcake_data.push(query);
    }

    indexPageView(data = {})
    {
        this.push(
            {
                pageType: 1,
                user: {
                    email: (data.user.authorized) ? data.user.email_md5 : ''
                }
            }
        );
    }

    productPageView(data = {})
    {

        let categoryParams = {};
        if (data.product.category_params) {
            categoryParams = {
                id: parseInt(data.product.category_params.ID),
                name: data.product.category_params.NAME
            };
        }

        this.push(
            {
                pageType: 2,
                user: {
                    email: (data.user.authorized) ? data.user.email_md5 : ''
                },
                currentCategory: categoryParams,
                currentProduct: {
                    id: parseInt(data.product.id),
                    name: data.product.name,
                    price: parseFloat(data.product.price)
                },
                basketProducts: this.formatBasket(data.basket)
            }
        );
    }



    basketPageViewed(data)
    {
        this.push(
            {
                pageType: 4,
                user: {
                    email: (data.user.authorized) ? data.user.email_md5 : ''
                },
                basketProducts: this.formatBasket(data.basket, true)
            }
        );
    }

    categoryPageViewed(data = {})
    {
        this.push(
            {
                pageType: 3,
                user: {
                    email: (data.user.authorized) ? data.user.email_md5 : ''
                },
                currentCategory: {
                    id: parseInt(data.category.id),
                    name: data.category.name
                },
                products: this.formatProducts(data.products),
                basketProducts: this.formatBasket(data.basket)
            }
        );
    }

    orderThankyouPageViewed(data)
    {
        this.push(
            {
                pageType: 6,
                user: {
                    email: (data.user.authorized) ? data.user.email_md5 : '',
                    type: ''
                },
                basketProducts: this.formatBasket(data.basket, true),
                orderInfo: {
                    id: data.order.id,
                    totalPrice: parseFloat(data.order.product_price),
                    coupon: data.order.coupon
                }
            }
        );
    }

    pageOrderView(data)
    {
        this.push(
            {
                pageType: 5,
                user: {
                    email: (data.user.authorized) ? data.user.email_md5 : '',
                    type: ''
                },
                basketProducts: this.formatBasket(data.basket, true)
            }
        );
    }


    formatProducts(products)
    {
        return products.map((productItem) => {
            return AdvCake.formatProductsItem(productItem);
        });
    }

    static formatProductsItem(productItem)
    {
        return {
            id: parseInt(productItem.id),
            name: productItem.name,
            price: parseFloat(productItem.price)
        };
    }

    formatBasket(basket, isBasketPage = false)
    {
        return basket.map((basketItem) => {
            return AdvCake.formatBasketItem(basketItem, isBasketPage);
        });
    }

    static formatBasketItem(basketItem, isBasketPage = false)
    {

        // eslint-disable-next-line no-unused-vars
        let categoryId, categoryName;

        if (!isBasketPage) {
            categoryId = parseInt(basketItem.section.ID);
            categoryName = basketItem.section.NAME;
        }
        if (isBasketPage) {
            categoryId = parseInt(basketItem.category_id);
            categoryName = basketItem.category;
        }

        return {
            id: parseInt(basketItem.offer_id) || parseInt(basketItem.id),
            name: basketItem.name,
            quantity: parseFloat(basketItem.quantity),
            price: parseFloat(basketItem.price),
            categoryId: categoryId,
            categoryName: categoryName
        };
    }
}


// WEBPACK FOOTER //
// ./modules/tracker/advcake.js